const notificationRoutes: any = {
    path: 'n',
    name: 'notifications',
    meta: { title: 'project_menu.notifications' },
    component: () => import('@/views/Notification/views/Notifications.vue'),
}

export default notificationRoutes
